import React, { ReactElement } from "react";
import Login from "@templates/Auth/Login";
import TemplateSEO from "@seo/TemplateSEO";

interface Props {}

export default function LoginPage({}: Props): ReactElement {
    return (
        <>
            {/* @ts-ignore */}
            <TemplateSEO urlPath="accounts/login" title="Login" />
            <Login />
        </>
    );
}
